export const getElementAttributes = (element: HTMLElement): Record<string, string> => {
  const attributes: Record<string, string> = {}
  for (let i = 0, atts = element.attributes, n = atts.length; i < n; i++) {
    const attribueName = atts[i].nodeName
    attributes[attribueName.toLowerCase()] = (atts[i].nodeValue || '').toString()
  }
  return attributes
}

export const buildElement = (type: string, klass: string, attributes: Record<string, string|boolean|number>): HTMLElement => {
  const element = document.createElement(type)
  element.setAttribute('class', klass)
  setAttributesOnElement(element, attributes)
  return element
}

export const setAttributesOnElement = (element: HTMLElement, attributes: Record<string, string|boolean|number>) => {
  const keys = Object.keys(attributes)
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (typeof attributes[key] !== 'undefined') {
      element.setAttribute(key, attributes[key].toString())
    }
  }
}

export const buildStyle = (map: Record<string, string>): string => {
  const keys = Object.keys(map)
  const styles = []
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    styles.push(`${key}:${map[key]}`)
  }
  return styles.join(';')
}

export function addAttributeToHtmlElement (element: string, attributeType: string, attributeValue: any) {
  const classElement = getHtmlElementByClassName(element)
  if (classElement) {
    classElement.setAttribute(attributeType, attributeValue)
    return
  }
  console.log(Error('Cannot add attributes to missing HTML element!'))
}

export function insertHtmlElement (element: string, insertPosition: any, html: any) {
  const classElement = getHtmlElementByClassName(element)
  if (classElement) {
    classElement.insertAdjacentHTML(insertPosition, html)
    return
  }
  console.log(Error('Cannot insert HTML element, missing class!'))
}

export function getHtmlElementById (id: string) {
  const element = document.getElementById(id)
  if (element) {
    return element
  }
  return null
}

export function getHtmlElementByClassName (className: string) {
  const element = (<HTMLInputElement>document.getElementsByClassName(className)[0])
  if (element) {
    return element
  }
  return null
}

export function removeHtmlElementByClassName (className: string) {
  const element = getHtmlElementByClassName(className)
  if (element) {
    element.remove()
  }
}

export function getHtmlElementByTagName (tagName: string) {
  const element = (<HTMLInputElement>document.getElementsByTagName(tagName)[0])
  if (element) {
    return element
  }
  return null
}

export function getHtmlElementValue (...classNames: any[]) {
  const formattedClassNames = classNames.toString().replace(',', ' ')
  const querySelector = (<HTMLInputElement>document.querySelector(formattedClassNames))
  if (querySelector) {
    return querySelector.value
  }
  return null
}
